module.exports = __webpack_public_path__ + "79ae938e6f62b28ee3ef97e43ee56629.svg";